import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      location: "Phoenix, AZ",
      image: "https://images.unsplash.com/photo-1634552516330-ab1ccc0f605e?crop=entropy&cs=srgb&fm=jpg&q=85&w=150&h=150",
      quote: "I was facing foreclosure and needed to sell fast. JJbuyshouses made me a fair offer and we closed in just 10 days. They saved me from a nightmare situation!",
      rating: 5,
    },
    {
      name: "Michael Rodriguez",
      location: "Dallas, TX",
      image: "https://images.unsplash.com/photo-1658288098101-84f074c292a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=150&h=150",
      quote: "After my father passed, we inherited a house that needed major repairs. JJbuyshouses bought it as-is and handled everything professionally. Highly recommend!",
      rating: 5,
    },
    {
      name: "Jennifer Thompson",
      location: "Atlanta, GA",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=150&h=150",
      quote: "I was relocating for work and needed to sell quickly. The whole process was smooth and transparent. Got my cash in two weeks. Amazing experience!",
      rating: 5,
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section id="testimonials" className="py-24 md:py-32 bg-slate-900" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block text-sm font-semibold text-[#D32F2F] uppercase tracking-wide mb-4">
            Success Stories
          </span>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            What Our Clients Say
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what homeowners across the country have to say about working with us.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700/50 hover:border-slate-600 transition-all duration-300 testimonial-card"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#D32F2F]/30 mb-4" />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-slate-300 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-slate-600"
                />
                <div>
                  <p 
                    className="font-semibold text-white"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                  >
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-slate-400">{testimonial.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
